const CloseIcon = ({
  className = "",
  onClick,
  pathClass = ""
}: {
  className?: string;
  onClick?: () => void;
  pathClass?: string;
}) => {
  return <svg width='20px' height='20px' stroke='currentColor' fill='currentColor' strokeWidth='0' viewBox='0 0 24 24' className={`${className} inline-block`} onClick={onClick} aria-hidden='true' data-sentry-element="svg" data-sentry-component="CloseIcon" data-sentry-source-file="CloseIcon.tsx">
      <path fill='none' d='M0 0h24v24H0z' data-sentry-element="path" data-sentry-source-file="CloseIcon.tsx"></path>
      <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' className={pathClass} data-sentry-element="path" data-sentry-source-file="CloseIcon.tsx"></path>
    </svg>;
};
export default CloseIcon;